export default __webpack_public_path__ + "static/media/296.31775f18.gif";